
export const getWorkListParametersRaw = (state) => {
    return state.workListDataParameters
  }
  
  export const getCurrentStudyGuid = (state) => {
    if (state && state.studyDetailData) {
      return state.studyDetailData.selectedGuid
    } else return null
  }
  
  export const getStudyDetailData = (state) => {
    return state.studyDetailData
  }
  
  export const getFormIOAuthToken = (state) => {
    return state.formIOAuthToken
  }
  
  export const getExternalPhysicians = (state) => {
    return state.externalPhysician
  }
  
  export const getInternalPhysicians = (state) => {
    return state.internalPhysician
  }
  
  export const getStudyListParametersRaw = (state) => {
    return state.studyListDataParameters
  }
  
  export const getIRStudyListParametersRaw = (state) => {
    return state.irStudyListDataParameters
  }
  
  export function delay (millis) {
    const promise = new Promise(resolve => {
      setTimeout(() => resolve(true), millis)
    })
    return promise
  }
  
  export const getFormValues = (state, name) => state.form[name] ? state.form[name].values : null;
  
  export const getUsers = (state) => {
    return state.users
  }